import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ISpecialProjectCommission } from '../interface/ISpecialProjectCommission';

enum SpecialProjectCommisionEnum {
  getBySpecialProject = "/",
}

export default class SpecialProjectCommissionService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/special-project/commission");
  }

  public getBySpecialProject = async (specialProjectId: number): Promise<ISpecialProjectCommission[]> => await this.GET(SpecialProjectCommisionEnum.getBySpecialProject + specialProjectId);
}
